import React from "react";
import PropTypes from "prop-types";
import { Flex } from "orcs-design-system";

const HelpContent = ({ text }) => {
  return (
    <Flex flexDirection="column" gap="xs" p="xs">
      {text
        .split("\n") // respect new lines
        .map((t) => t.trim()) // clean up white space
        .filter((t) => t) // remove empties
        .map((t) => {
          return <div key={t}>{t}</div>;
        })}
    </Flex>
  );
};

HelpContent.propTypes = {
  text: PropTypes.string.isRequired,
};

export default HelpContent;
